import ApiInstance from './instance'
import {
  URL_MAPPING,
  ICollectionFlowDTO,
  ICollectionTaskCalledResidentDTO,
  ICollectionTask,
  ICollectionFlow,
  IFacilityCollectionFlowsFilters,
  IFacilityCollectionFlowsResult,
  ICollectionTasksFilters,
  ICollectionTasksResult,
  ICollectionTaskSendMailDTO,
  ICollectionHistory,
  ICollectionTaskChangeEscalationDTO
} from '@zunta/configurations'
import { ICollectionTaskPostponeDTO } from '@zunta/configurations/dist/types/data-transfer-object/collection-flow-dto'

const { collectionFlow: collectionFlowUrls } = URL_MAPPING

export default class CollectionFlowApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  async createCollectionFlows (facilityIds: number[], collectionFlowData: ICollectionFlowDTO): Promise<ICollectionFlow[]> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.createCollectionFlows.path}`, {
      facilityIds,
      data: collectionFlowData
    })
  }

  async createCollectionFlow (facilityId: number | string, collectionFlowData: ICollectionFlowDTO): Promise<ICollectionFlow> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.createCollectionFlow.path}/${facilityId}`, collectionFlowData)
  }

  async updateCollectionFlow (collectionFlowId: number | string, collectionFlowData: ICollectionFlowDTO): Promise<'OK'> {
    return this.instance.doPut(`${collectionFlowUrls.prefix}${collectionFlowUrls.updateCollectionFlow.path}/${collectionFlowId}`, collectionFlowData)
  }

  async getCollectionFlowById (collectionFlowId: number | string): Promise<ICollectionFlowDTO> {
    return this.instance.doGet(`${collectionFlowUrls.prefix}${collectionFlowUrls.getCollectionFlowById.path}/${collectionFlowId}`)
  }

  async getFacilityCollectionFlows (facilityId: number | string, filters: IFacilityCollectionFlowsFilters): Promise<{ total: number, items: IFacilityCollectionFlowsResult[] }> {
    return this.instance.doGet(`${collectionFlowUrls.prefix}${collectionFlowUrls.getFacilityCollectionFlows.path}/${facilityId}`, filters)
  }

  async getAllCollectionFlows (): Promise<ICollectionFlow[]> {
    return this.instance.doGet(`${collectionFlowUrls.prefix}${collectionFlowUrls.getAllCollectionFlows.path}`)
  }

  async deleteCollectionFlow (collectionFlowId: number | string) {
    return this.instance.doDelete(`${collectionFlowUrls.prefix}${collectionFlowUrls.deleteCollectionFlow.path}/${collectionFlowId}`)
  }

  async getCollectionTasksByFilters (filters: ICollectionTasksFilters): Promise<ICollectionTasksResult> {
    return this.instance.doGet(`${collectionFlowUrls.prefix}${collectionFlowUrls.getCollectionTasks.path}`, filters, null, { isCompressed: true })
  }

  async getCollectionTasksWithAgingByFilters (filters: any): Promise<any> {
    return this.instance.doGet(`${collectionFlowUrls.prefix}/getCollectionTasksWithAging`, filters)
  }

  async scheduleCallWithResident (residentId: number | string, data: Partial<ICollectionTask>): Promise<ICollectionTask> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.scheduleCallWithResident.path}/${residentId}`, data)
  }

  async takeActionResidentCalled (residentId: number | string, data: ICollectionTaskCalledResidentDTO) {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.residentCalled.path}/${residentId}`, data)
  }

  async changeCollectionTaskAssignedUser (collectionTaskId: number | string, assignedUser: number, facilityId: number, residentId: number, currentUserId: number): Promise<'OK'> {
    return this.instance.doPut(`${collectionFlowUrls.prefix}${collectionFlowUrls.changeCollectionTaskAssignedUser.path}/${collectionTaskId}`, {
      assignedUser,
      facilityId,
      residentId,
      currentUserId
    })
  }

  async takeActionSendMailToResidentContact (residentId: number | string, data: ICollectionTaskSendMailDTO): Promise<ICollectionTask> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.sendMailToResidentContact.path}/${residentId}`, data)
  }

  async changeResidentEscalation (residentId: number | string, data: ICollectionTaskChangeEscalationDTO): Promise<ICollectionTask> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.changeEscalation.path}/${residentId}`, data)
  }

  async postponeResidentCollection (residentId: number | string, data: ICollectionTaskPostponeDTO): Promise<ICollectionTask> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}/postponeResidentCollection/${residentId}`, data)
  }

  async addResidentCollectionHistoryNote (residentId: number | string, data: { user: number, note: string }): Promise<ICollectionHistory> {
    return this.instance.doPost(`${collectionFlowUrls.prefix}${collectionFlowUrls.addHistoryNote.path}/${residentId}`, data)
  }

  async updateCollectionHistoryItem (historyId: number | string, payload: any) {
    return this.instance.doPut(`${collectionFlowUrls.prefix}/updateHistoryItem/${historyId}`, payload)
  }
}
